import { z } from 'zod';
import { KeyValueSchema } from '../dataSource/Common';
import {
  BaseProcessingScheduleSchema,
  ProcessingScheduleSchemaValidation,
} from '../ProcessingScheduleSchema';
import { BaseComputeGroupSchema } from '../ComputeGroupSchema';
import {
  StreamTableSchema,
  superRefineStreamTableSchema,
} from '../StreamTableSchema';

export const Fidelity = ['Investigative', 'Medium', 'High'] as const;

export const AddDetectionRuleSchema = z
  .object({
    name: z.string(),
    comment: z.string().optional(),
    annotations: z.array(KeyValueSchema),
    severity: z.string(),
    category: z.string(),
    fidelity: z.enum([...Fidelity, '']),
    objective: z.string().optional(),
    taxonomy: z.string().optional(),
    tactic: z.string().optional(),
    techniqueId: z.string().optional(),
    technique: z.string().optional(),
    subTechniqueId: z.string().optional(),
    subTechnique: z.string().optional(),
    enabled: z.boolean(),
    ruleInput: z.enum(['streaming', 'batch']),
    notebookType: z.enum(['custom', 'inline']),
    customNotebookPath: z.string().optional(),
    customNotebookParameters: z.array(KeyValueSchema),
    batchSql: z.string().optional(),
    streamingTables: z.array(StreamTableSchema),
    streamingFilter: z.string().optional(),
    streamingSql: z.string().optional(),
    observables: z.array(
      z.object({
        kind: z.string(),
        value: z.string(),
        relationship: z.string(),
        risk: z
          .object({
            impact: z.string(),
            confidence: z.string(),
          })
          .optional(),
      }),
    ),
    output: z.object({
      summary: z.string().optional(),
      context: z.array(KeyValueSchema),
    }),
    collate: z.object({
      on: z.array(z.string().optional()),
      within: z.string().optional(),
      action: z.enum(['append', 'updateStats', 'inhibit']),
    }),
  })
  .merge(BaseProcessingScheduleSchema)
  .merge(BaseComputeGroupSchema)
  .superRefine((data, ctx) => {
    if (data.collate.on.filter((q) => !!q).length && !data.collate.within) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Collate requires a within duration',
        path: ['collate', 'within'],
      });
    }
  })
  .superRefine(...ProcessingScheduleSchemaValidation)
  .superRefine((data, ctx) =>
    superRefineStreamTableSchema(data.streamingTables, ctx, 'streamingTables'),
  );

export type AddDetectionRuleSchemaValues = z.infer<
  typeof AddDetectionRuleSchema
>;
